//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 안전보건목표 및 추진계획 (POL_BASIC_02) 전용 로직
 * other 케이스에서 사용
 */

// 안전보건목표 및 추진계획 인쇄 함수
export const PrintLogic1 = async (
  documentData, // documentData는 사용하지 않지만 시그니처 통일을 위해 유지
  dispatch,
  setLoading,
  rowData1,
  inputs1
) => {
  setLoading(true);
  try {
    let headerData = {};
    let tableData = [];

    // 오늘 날짜 정보 생성
    let today = new Date();
    let year = today.getFullYear(); // 년도
    let month = String(today.getMonth() + 1).padStart(2, '0'); // 월
    let date = String(today.getDate()).padStart(2, '0'); // 날짜

    // 헤더 데이터 설정
    headerData = inputs1 || {};
    headerData.today = year + '년 ' + month + '월 ' + date + '일';

    // 테이블 데이터 설정
    const result = await apiRequest(
      'post',
      Global.urls.DocsManagement.getPolBasic02R2,
      {
        Chaebun: Commons.EncryptAES(documentData.chaebun || ''),
        SearchText: Commons.EncryptAES(''),
      }
    );

    const data = result.data;

    if (data.length === 0 || data[0]?.type === 'Error') {
      dispatch(
        showSnackbar({
          message: data[0]?.message || '인쇄할 데이터가 없습니다.',
          type: 'error',
        })
      );
      return null;
    }

    tableData = data;

    const printData = {
      FileName: 'POL_BASIC_02',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 데이터 생성에 실패했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
